import { GetDoc } from "@/Utils/StateLib";
import { Flex, Text, TooltipWrapper } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";

const hiddenFieldIds = ["PersonID", "Name", "treeID"];

export const MismatchDisplayRow = ({ mismatch }) => {
  const doc = GetDoc();
  if (!doc) {
    return null;
  }

  const objDB = doc.GetObjDB();
  const boxClass = objDB.GetClassByName("Box");

  const invalidFields = Object.entries(mismatch).reduce((acc, [fieldName, fieldValue]) => {
    const fieldDef = boxClass.GetFieldDefByName(fieldName);
    const fieldId = fieldDef.GetFieldID();
    const isPicklist = fieldDef?.IsPickList();

    if (!isPicklist || hiddenFieldIds.includes(fieldId)) {
      return acc;
    }

    const invalid = fieldDef.GetPickValues().indexOf(fieldValue) === -1;
    if (!invalid) {
      return acc;
    }

    return {
      ...acc,
      [fieldName]: fieldValue
    };
  }, {});

  return (
    <Flex direction={"column"}>
      {Object.entries(invalidFields).map(([field, value]) => (
        <TooltipWrapper
          key={field}
          tooltipProps={{ message: field + " " + appstr("is invalid value") + " " + value }}
        >
          <Flex className={"oc-text-truncate--1"}>
            <Text size={"xsmall"} modifier={"medium"}>
              {field}
            </Text>
            <Text size={"xsmall"} colorModifier={"grey"}>
              {" " + appstr("is invalid value") + " "}
            </Text>
            <Text size={"xsmall"} modifier={"medium"}>
              {value}
            </Text>
          </Flex>
        </TooltipWrapper>
      ))}
    </Flex>
  );
};
